import { Box } from "@material-ui/core";
import {
  DataGrid,
  GridColumns,
  GridValueFormatterParams,
} from "@material-ui/data-grid";
import { parseISO, format } from "date-fns";
import { FC, useMemo, useCallback } from "react";
import { EventsTableProps } from "./types";

export const EventsTable: FC<EventsTableProps> = ({
  data,
  pageNumber,
  loading,
  totalNumberOfRows,
  handlePageChange,
  handlePageSizeChange,
}) => {
  const renderValue = useCallback(
    ({ row, field }: GridValueFormatterParams) => {
      return (
        <Box display={"flex"} alignItems={"center"} width={"100%"}>
          {row[field]}
        </Box>
      );
    },
    []
  );

  const renderTime = useCallback(({ row, field }: GridValueFormatterParams) => {
    return (
      <Box display={"flex"} alignItems={"center"} width={"100%"}>
        {format(parseISO(row[field]), "dd.MM.yyyy hh:mm")}
      </Box>
    );
  }, []);

  const datagridRows = useMemo(
    () =>
      data.map((item) => ({
        ...item,
        id: item.eventId,
      })),
    [data]
  );

  const columns = useMemo<GridColumns>(
    () => [
      {
        field: "id",
        headerName: "id события",
        width: 145,
        editable: false,
        renderCell: renderValue,
      },
      {
        field: "eventName",
        headerName: "Событие",
        width: 350,
        editable: false,
        renderCell: renderValue,
      },
      {
        field: "date",
        headerName: "Время поступления",
        flex: 1,
        editable: false,
        renderCell: renderTime,
      },
      {
        field: "workTime",
        headerName: "Длительность",
        flex: 1,
        editable: false,
        renderCell: renderValue,
      },
    ],
    []
  );

  return (
    <DataGrid
      columns={columns}
      rows={datagridRows}
      checkboxSelection={false}
      disableColumnResize={true}
      hideFooter={false}
      disableSelectionOnClick={true}
      disableColumnMenu={true}
      autoHeight={true}
      paginationMode="server"
      page={pageNumber}
      onPageChange={handlePageChange}
      onPageSizeChange={handlePageSizeChange}
      loading={loading}
      rowCount={totalNumberOfRows}
    />
  );
};
